import React from "react";
import type { ArticleSource } from "@/domains/articles/Article";

export interface ArticleSourcesProps {
  sources: readonly ArticleSource[];
}

export const ArticleSources: React.FC<ArticleSourcesProps> = ({ sources }) => {
  if (sources.length === 0) {
    return null;
  }

  return (
    <div className="rounded-2xl border border-primary-100 bg-white p-4 shadow-sm">
      <p className="text-sm font-bold text-primary-700">出典</p>
      <ol className="mt-2 list-decimal space-y-2 pl-5 marker:text-primary-400">
        {sources.map((source, index) => (
          <li
            key={source.url}
            id={`source-${index + 1}`}
            className="scroll-mt-28 target:rounded-md target:bg-primary-50"
          >
            <a
              href={source.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-primary-600 underline decoration-primary-300 underline-offset-2 hover:text-primary-800"
            >
              {source.title}
            </a>
            {source.note && (
              <p className="mt-0.5 text-xs leading-5 text-primary-500">
                {source.note}
              </p>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
};
